import { InboxNotiDto } from '@diritto/common/notification/dtos/inbox-noti.dto';
import { Color } from '@diritto/common/style/color';
import { convertToDotString, convertToRelativeString } from '@diritto/common/utils/date';
import { LikeCircleIcon } from 'icons/LikeCircleIcon';
import * as Styled from 'app-components/inbox/items/styles';
import React, { useState } from 'react';
import { Divider } from 'ui-components/common/Divider';
import { Link } from 'ui-components/common/Link';

interface ReplyLikeInboxNotiListItemProps {
  inboxNoti: InboxNotiDto;
  link: string;
}

export const ReplyInboxLikeNotiListItem = ({ inboxNoti, link }: ReplyLikeInboxNotiListItemProps) => {
  const [isRead] = useState(inboxNoti.isRead);

  return (
    <Link href={link}>
      <Styled.Container>
        <Styled.LeftIconSection>
          <Styled.Unread isRead={isRead} />
          <LikeCircleIcon className="size-[56px]" />
        </Styled.LeftIconSection>
        <Styled.RightSection>
          <Styled.TitleWrapper>
            <Styled.SanitizeHTMLTitle
              html={`${inboxNoti.title}<span class="inbox-title-date" title="${convertToDotString(
                inboxNoti.sentAt,
              )}">${convertToRelativeString(inboxNoti.sentAt)}</span>`}
              options={{
                allowedTags: ['b', 'span', 'br'],
                allowedClasses: {
                  span: ['inbox-title-date'],
                },
                allowedAttributes: { span: ['title'] },
              }}
            />
          </Styled.TitleWrapper>
        </Styled.RightSection>
        <Divider color={Color.Gray200} />
      </Styled.Container>
    </Link>
  );
};
